// extracted by mini-css-extract-plugin
module.exports = {"button":"logo-moises_button__QqE4p","image":"logo-moises_image__kF1cV","small":"logo-moises_small__uhO4W"};